import React from "react";
import "../../CSS/general.css";

const ActionButtons = (props) => {


    const handleNext = () => {
        props.nextStep();
    };

    const handleFinish = () => {
        props.closePopupModal();
    };

    const handleCancel = () => {
        props.closePopupModal();
    };

    return (
        <div>
            {props.currentStep < props.totalSteps && (
                <button onClick={handleNext} disabled={props.isDisabled} aria-hidden={props.isDisabled ? 'true' : 'false'}
                    tabIndex={props.isDisabled ? -1 : 0}  style={{ cursor: props.isDisabled ? 'not-allowed' : 'pointer', }}
                    className="btn btn-primary btn-sm me-2">Next</button>
            )}
            {props.currentStep === props.totalSteps && (
                <button onClick={handleFinish} disabled={props.isDisabled} aria-hidden={props.isDisabled ? 'true' : 'false'}
                    tabIndex={props.isDisabled ? -1 : 0} style={{ cursor: props.isDisabled ? 'not-allowed' : 'pointer', }} className="btn btn-primary btn-sm me-2">Finish</button>
            )}
            <button onClick={handleCancel} className="btn btn-outline-primary btn-sm">Cancel</button>
        </div>
    );
};
export default ActionButtons;